import config from "src/config.js";
import { BaseAuth } from "./base-auth.js";
import { KeyCloakAuth } from "./keycloak-auth.js";
import { OAuthService } from "./oauth-auth.js";

export class AuthService {
    /**
     * Constructor
     */
    constructor() {
        const authType = config.env("VITE_AUTH_TYPE");
        if (authType === "keycloak") {
            this.auth = new KeyCloakAuth();
        } else if (authType === "oauth") {
            this.auth = new OAuthService();
        } else {
            this.auth = new BaseAuth();
        }
    }
}
